import { Palette } from '@mui/material/styles';

import { StyleRules } from '@mui/styles';

// needs CssBaseline component after ThemeProvider

export default (palette: Palette): Partial<StyleRules> => ({
  styleOverrides: {
    body: {
      fontSize: '1rem',
      lineHeight: 1.143,
      letterSpacing: 'normal',
    },
    html: {
      '*::-webkit-scrollbar': {
        width: 8,
        height: 8,
      },
      '*::-webkit-scrollbar-track': {
        background: palette.navigation.background,
        borderRadius: '10px !important',
      },
      '*::-webkit-scrollbar-thumb': {
        background: palette.navigation.contrastText,
        borderRadius: '10px !important',
      },
    },
  },
});
